import { render, staticRenderFns } from "./AddPassengerDetails.vue?vue&type=template&id=c0d874c2&scoped=true&"
import script from "./AddPassengerDetails.vue?vue&type=script&lang=js&"
export * from "./AddPassengerDetails.vue?vue&type=script&lang=js&"
import style0 from "./AddPassengerDetails.vue?vue&type=style&index=0&id=c0d874c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d874c2",
  null
  
)

export default component.exports